export default {
  data: function() {
    return {
      products: [
        // Auto Rates
        {
          name: '72 month',
          id: 311,
          group: 'purchase',
          months: 72,
          purchaseType: 'new'
        },
        {
          name: '60 month',
          id: 73,
          group: 'purchase',
          months: 60,
          purchaseType: 'used'
        },
        {
          name: '60 month',
          id: 41,
          group: 'purchase',
          months: 60,
          purchaseType: 'new'
        },
        {
          name: '48 month',
          id: 74,
          group: 'purchase',
          months: 48,
          purchaseType: 'used'
        },
        {
          name: '48 month',
          id: 39,
          group: 'purchase',
          months: 48,
          purchaseType: 'new'
        },
        {
          name: '36 month',
          id: 42,
          group: 'purchase',
          months: 36,
          purchaseType: 'used'
        },
        {
          name: '36 month',
          id: 40,
          group: 'purchase',
          months: 36,
          purchaseType: 'new'
        }
      ],

      loanAmountInfo: [
        {
          copy:
            'The amount you need to borrow to purchase your car. This could include a down payment and any estimated fees from your car purchase.'
        }
      ],

      advertiserDisclosure: {
        copy:
          'The listings that appear on this page are from companies from which this website receives compensation, which may impact how, where and in what order products appear. This table does not include all companies or all available products. Bankrate does not endorse or recommend any companies.'
      },

      rateTableDisclosure: {
        copy:
          '<p>The rate information above is obtained by Bankrate from the listed institutions. Bankrate cannot guaranty the accuracy or availability of any rates shown above. Institutions may have different rates on their own websites than those posted on Bankrate.com.</p> ' +
          '<p>All rates are subject to change without notice and may vary branch to branch. These quotes are from banks, thrifts, and credit unions, some of whom have paid for a link to their own Web site where you can find additional information. Those with a paid link are our Advertisers. Those without a paid link are listings we obtain to improve the consumer shopping experience and are not Advertisers. To receive the Bankrate.com rate from an Advertiser, please identify yourself as a Bankrate customer. Bank and thrift deposits are insured by the Federal Deposit Insurance Corp. Credit union deposits are insured by the National Credit Union Administration.</p>' +
          "<p>Consumer Satisfaction: Bankrate attempts to verify the accuracy and availability of its Advertisers' terms through its quality assurance process and requires Advertisers to agree to our Terms and Conditions and to adhere to our Quality Control Program. If you believe that you have received an inaccurate quote or are otherwise not satisfied with the services provided to you by the institution you choose, please <a class='rate-table__row-copy --small --link' href='mailto:qualitycontrol@bankrate.com'>click here</a>.</p>" +
          "<p>Rate collection and criteria: <a class='rate-table__row-copy --small --link' href='/funnel/auto/product-criteria.aspx?prodtype=auto'>Click here</a> for more information on rate collection and criteria.</p>"
      },

      CalculatorCard1: {
        copy:
          'Looking to refinance an existing auto loan?  Bankrate.com can help you lower your interest rate or monthly payment with 36, 48 or 60 month auto loan refinancing options.',
        linkUrl: '/loans/auto-loans/rates?product=Refinance'
      },

      CalculatorCard2: {
        copy:
          'Bankrate.com provides a FREE lease or buy a car calculator and other auto calculators to help consumers decide between a car lease or an auto purchase.',
        linkUrl: '/calculators/auto/lease-buy-car.aspx'
      },

      StoryCard1: {
        copy:
          "You should consider several factors when deciding when the right time to buy a car is. In general, you'll get a better deal if you buy a car on a weekday versus the weekend.",
        linkUrl: '/finance/auto/when-is-best-time-to-buy-car.aspx'
      },

      StoryCard2: {
        copy:
          "It's the most wonderful time of the year -- to buy a car, at least. Here are some of the best tips auto insiders give their family and friends.",
        linkUrl: '/finance/auto/car-shopping-tips-from-industry-insiders-1.aspx'
      },

      Tip1: {
        copy:
          "Never cosign for an auto loan. Yes, they may need your help. Yes, they may be a great friend or your own flesh and blood. But it's never a good idea - especially if you aren't planning on having to pay off the entire loan when the person who signs for it defaults."
      },

      Tip2: {
        copy:
          "Before going to the car lot, try lining up your financing at a local credit union first. Credit unions often offer better rates than banks and financing companies at car dealerships. Once your financing is lined up, you'll know how much you can spend on a car."
      },

      Tip3: {
        copy:
          "Don't buy a car you can't afford. Too often car shoppers think about the final number they are willing to pay and don't factor in taxes, title fees and other expenses. These extras often add up to more than a buyer can comfortably pay."
      }
    }
  }
}
